'use strict';

const { history } = require('dibs-backbone');
const $ = require('dibs-jquery-shim');
const SV = require('server-vars');
const React = require('react');
const ReactDOM = require('react-dom');
const PageRoot = require('../newPdp/NewPdpRoot');
const createEntryPointContext = require('../global/reactHelpers/createEntryPointContext.es');
const urlData = require('bunsen/helpers/uri').parseUri(global.location, {stripDelimiters: true});
const returnsCopy = require('../../../json/copy/returnsCopy');
const isEmpty = require('lodash.isempty');
const findNamespaceValue = require('find-namespace-value');
const root = require('bunsen/helpers/windowCheck');
const {currencies} = require('dibs-currency-helpers/constants');
const remarketingTag = require('../global/modules/commonjs/remarketingTag');
const ItemStore = require('../newPdp/stores/ItemStore.es');
const PdpUiStore = require('../newPdp/stores/PdpUiStore.es');
const PriceStore = require('../global/stores/PriceStore.es.js');
const User = require('../global/models/User');
const loginActions = require('../global/actions/loginActions.es');
const currencyActionConstants = require('../global/constants/currencyActionConstants.es');
const {createReducerStore} = require('fluxible-reducer-store');
const pdpActionsConstants = require('../newPdp/actions/pdpActionsConstants.es');
const sourceAttributionHelper = require('../global/utils/sourceAttributionHelper');
const GalleryModalRouter = require('../gallery/modal/GalleryModalRouter.es');
const GalleryModalWrapperView = require('../gallery/modal/GalleryModalWrapperView.es');
const galleryModalActions = require('../gallery/modal/galleryModalActions.es');
const galleryActions = require('../gallery/actions/galleryActions.es');
const categoriesActions = require('../global/actions/categoriesActions');
const GAC = require('../gallery/helpers/GalleryConstants.es');
const pdpActions = require('../newPdp/actions/PdpActions.es');

const stores = [
    ItemStore,
    PdpUiStore,
    createReducerStore(require('../gallery/modal/GalleryModalStore.es')),
    createReducerStore(require('../gallery/stores/GalleryStore.es')),
    createReducerStore(require('../gallery/stores/GalleryPhotoUIStore')),
    createReducerStore(require('../global/stores/CreatorsStore')),
    createReducerStore(require('../global/stores/CategoriesStore')),
    createReducerStore(PriceStore),
    require('../components/Tour/TourStore'),
    require('../global/stores/PinterestStore'),
    require('../global/stores/SocialNetworkStore'),
    require('../user/stores/UserSocialNetworkStore'),
    require('../global/stores/FavoritesStore'),
    require('../global/stores/FavoritePageStore'),
    require('../global/stores/TradeMessageStore')
];

require('dibs-portfolio-folder/dist/styles.css');
require('../../scss/new-pdp/new-pdp.scss');
require('dibs-portfolio-heart/dist/styles.css');
require('dibs-elements/dist/buyer.css');

require('bunsen/helpers/copyText')
    .addGlobalSVPath('copy.contactDealer')
    .addGlobalSVPath('copy');

/**
 * Convenience method that executes an action, which dispatches event with given payload
 * @param {object} context
 * @param {string} eventName
 * @param {object} [payload={}]
 * @returns {Promise}
 */
const executeAction = (context, eventName, payload = {}) => {
    return context.executeAction((actionContext, p) => {
        actionContext.dispatch(eventName, p);
    }, payload);
};

sourceAttributionHelper.trackPreRegistrationPageVisit();

// Need to wrap this in a jquery ready function to keep tracking working. In the component
// did mount method of pdpLayout, pdpTracking.updateGaReturns is called which in turn
// publishes the event 'ga:unblockCustomVar'. A subscriber in gas.dibs.pageview catches this
// and kicks off the tracking for the pdp. However, if the code below isn't wrapped in a
// jquery ready, the publish event will fire before the subscriber is set up. Tracking will
// never start as a result.
// Todo Long term solution is to refactor gas.dibs.pageview to follow Flux pattern. Would also
// be ideal to rewrite jquery's document.ready method in vanilla javascript and remove all the
// jquery on this page in the mean time.
$(function () {
    const state = SV.get('jsTemplatesState') || {};
    const promises = [];
    let promise;

    // Set this up like NYDC page routing through the node app
    // If state is empty, page is routed through PHP
    if (isEmpty(state)) {
        const context = createEntryPointContext(stores, {connectToContact: true});
        const currency = findNamespaceValue('currency', root.essentialPropsForPdpSidebar);

        // Async data takes precedence and overwrites POST data from Item Preview
        if (!SV.get('data.isPreview')) {

            promises.push(context.executeAction(pdpActions.asyncLoadItem, { pk: SV.get('data.pk') }));
        }

        if (User.loggedIn()) {
            promises.push(context.executeAction(loginActions.loadFullUser));
            promises.push(context.executeAction(loginActions.checkUserTypeStatus));
        } else {
            promises.push(context.executeAction(loginActions.loadLoggedOutUser));
        }

        // Dispatch generic page received event
        promises.push(executeAction(context, pdpActionsConstants.ACTION_RECEIVE_PAGE));

        promises.push(executeAction(context, pdpActionsConstants.ACTION_PRINT_PAGE, {
            isPrintPage: SV.get('settings.isPrintPDP'),
            isPrintNP: SV.get('settings.isPrintNP')
        }));

        if (SV.get('settings.isPrintPDP')) {
            promises.push(executeAction(context, pdpActionsConstants.ACTION_CAROUSEL_INDEX, {
                index: Number(SV.get('settings.selectedImage')) || 0
            }));
        }

        // Dispatch events to populate stores
        promises.push(executeAction(context, 'BOOTSTRAP_ITEM_STORE',
            {
                breadcrumbs: SV.get('breadcrumbs'),
                creatorRoleReferences: SV.get('creatorRoleReferences'),
                conditionReferences: SV.get('conditionReferences'),
                copy: SV.get('pdpCopy'),
                rawResult: SV.get('rawResult'),
                detailLinks: SV.get('detailLinks'),
                detailTechniques: SV.get('detailTechniques'),
                detailsTitles: SV.get('detailsTitles'),
                goodRelationsMeta: SV.get('goodRelationsMeta'),
                periodReferences: SV.get('periodReferences'),
                pageData: SV.get('data') || {},
                returnsCopy,
                shippingCopy: SV.get('data.shippingCopy') || {},
                shouldShowSuspended: SV.get('data.isSuspended') || SV.get('data.isDeleted') || SV.get('data.isDealerSuspended'),
                tradeReturnsEnabled: SV.get('settings.enabler.trade_returns_enabled'),
                urlData
            }
        ));
        promises.push(executeAction(context, 'BOOTSTRAP_SHIPPING_STORE',
            {
                rawResult: SV.get('rawResult'),
                returnsCopy,
                shipmentQuotes: findNamespaceValue('shipmentQuotes', root.essentialPropsForPdpSidebar),
                shipping: SV.get('data.shippingCopy') || {}
            }
        ));

        const photos = SV.get('recommendedPhotos') || [];

        // Fetch the categories for the CategoriesStore
        promises.push(context.executeAction(categoriesActions.fetchGalleryCategories));

        promises.push(context.executeAction(galleryActions.setupStoreWithMultipleProjectPhotos,
            Object.assign({},
                {
                    galleryPhotos: photos,
                    initialPhoto: photos.length ? photos[0] : null,
                    totalPhotos: photos.length
                }
            )
        ));

        // Set Up the gallery modal store and project views
        promises.push(context.executeAction(galleryModalActions.setupStoreWithServerVars,
            {
                originalUrl: location.pathname + location.search,
                originalPageTitleTag: document.querySelector('title').innerHTML,
                originalPageType: GAC.pageTypes.PDP,
                originalDataLayerInfo: SV.get('tracking.initialDataLayerInfo'),
                originalVPVString: window.virtualPageName ? `/${window.virtualPageName.join('/')}/` : void 0
            }
        ));

        if (currency) {
            promises.push(executeAction(context, currencyActionConstants.CURRENCY_CHANGED, { currency }));
            promises.push(executeAction(context, currencyActionConstants.CURRENCY_LOADED));
        }
        promise = Promise.all(promises).then(() => {
            // Return context here to mimic resolve from createEntryPointContext
            return context;
        });
    } else {
        // If state is not empty, page is routed through Node App and Flux App must be rehydrated
        promise = createEntryPointContext(stores, { state });
    }

    promise.then((cxt) => {
        const itemStore = cxt.getStore(ItemStore);
        const item = itemStore.getItem();

        history.start({ root: '/', pushState: true, silent: true });

        new GalleryModalWrapperView({ context: cxt });
        new GalleryModalRouter({ context: cxt });

        ReactDOM.render(
            React.createElement(
                PageRoot,
                {
                    context: cxt.getComponentContext()
                }
            ),
            document.body.querySelector('.pdp-wrapper')
        );

        // Re-marketing tag should fire just for available PDP
        item.once('change', () => {
            if (!itemStore.getIsSold() && !itemStore.getIsOnHold() && !itemStore.getHidePrice()) {
                const id = item.get('id');
                const price = item.getAmountIn(currencies.CURRENCY_USD) || 0;
                remarketingTag.product(id, price);
            }
        });
    });
});



// WEBPACK FOOTER //
// ./assets/js/entries/newPdp.es.js